import _ from 'lodash';

/**
 * Get role data
 * @param roleKey
 * @param store
 * @returns {unknown}
 */
export function getRoleData(roleKey, store) {
  const { state } = store;
  return _.find(state.app.allRoles, { key: roleKey });
}
